import { ChangeDetectorRef, Component, inject, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TreeNode } from 'primeng/api';
import { combineLatest, firstValueFrom } from 'rxjs';
import { Folder_FIN_Path, Folder_Permission_Tree } from 'src/app/Interfaces/Libraries/Library-FIN-int/Folder_FIN.interface';
import { PermissionDirectoryFIN, permissionFIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Permissions/Permission_FIN.interface';
import { Response_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Response_FIN.interface';
import { ColumnFIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Role/ColumnFIN.interface';
import { CreateRoleFIN, Folder_Father } from 'src/app/Interfaces/Libraries/Library-FIN-int/Role/CreateRoleFIN.interface';
import { LibraryFINService } from 'src/app/Services/Libraries/General-FIN/library-fin.service';
import Swal from 'sweetalert2';


@Component({
    selector: 'app-create-role-cdmsfin',
    templateUrl: './create-role-cdmsfin.component.html',
    styleUrls: ['./create-role-cdmsfin.component.scss', '../../../../../Styles/GlobalStyles.css', '../../../../../Styles/RoleGlobal.scss'],
    standalone: false
})


export class CreateRoleCDMSFINComponent implements OnInit {

  //-========================= SECTION VARIABLES =========================-\\

  //+================== VARIABLES FOR HEADERS ==================+\\
  public HeaderGroup: ColumnFIN[] = [
    { ID: 0, field: 'Name', header: 'Name', icon: '', key_Header: 'Name', description: 'Nombre de carpeta' },
    { ID: 1, field: 'createFile', header: 'createFile', icon: 'fa-file-upload', key_Header: 'createFile', description: 'Cargar archivo' },
    { ID: 2, field: 'createFolder', header: 'createFolder', icon: 'fa-folder-plus', key_Header: 'createFolder', description: 'Crear carpeta' },
    { ID: 3, field: 'updateFile', header: 'updateFile', icon: 'fa-file-pen', key_Header: 'updateFile', description: 'Actualizar archivo' },
    { ID: 4, field: 'versionHistory', header: 'versionHistory', icon: 'fa-arrow-up-right-dots', key_Header: 'versionHistory', description: 'Ver historial de versiones' },
    { ID: 5, field: 'downloadVersionFlow', header: 'downloadVersionFlow', icon: 'fa-file-download', key_Header: 'downloadVersionFlow', description: 'Descargar versiones de historial' },
    { ID: 6, field: 'renameFile', header: 'renameFile', icon: 'fa-pencil-alt', key_Header: 'renameFile', description: 'Renombrar archivo' },
    { ID: 7, field: 'renameFolder', header: 'renameFolder', icon: 'fa-pen-to-square', key_Header: 'renameFolder', description: 'Renombrar carpeta' },
    { ID: 8, field: 'moveFile', header: 'moveFile', icon: 'fa-up-down-left-right', key_Header: 'moveFile', description: 'Mover archivo' },
    { ID: 9, field: 'moveFolder', header: 'moveFolder', icon: 'fa-expand-arrows-alt', key_Header: 'moveFolder', description: 'Mover carpeta' },
    { ID: 10, field: 'sharedFolder', header: 'sharedFolder', icon: 'fa-share-nodes', key_Header: 'sharedFolder', description: 'Compartir carpeta' },
    { ID: 11, field: 'adminApprovation', header: 'adminApprovation', icon: 'fa-check-double', key_Header: 'adminApprovation', description: 'Aprobar como administrador' },
    { ID: 12, field: 'adminRejection', header: 'adminRejection', icon: 'fa-xmark', key_Header: 'adminRejection', description: 'Rechazar como administrador' },
    { ID: 13, field: 'properties', header: 'properties', icon: 'fa-file-pen', key_Header: 'properties', description: 'Modificar propiedades' },
    { ID: 14, field: 'deleteFile', header: 'deleteFile', icon: 'fa-trash-can', key_Header: 'deleteFile', description: 'Eliminar archivo' },
    { ID: 15, field: 'deleteFolder', header: 'deleteFolder', icon: 'fa-folder-minus', key_Header: 'deleteFolder', description: 'Eliminar carpeta' },
    { ID: 16, field: 'versionHistoryAnnexe', header: 'versionHistoryAnnexe', icon: 'fa-arrow-up-right-dots', key_Header: 'versionHistoryAnnexe', description: 'Ver historial de anexos' },
    { ID: 17, field: 'downloadVersionAnnexe', header: 'downloadVersionAnnexe', icon: 'fa-download', key_Header: 'downloadVersionAnnexe', description: 'Descargar versiones de anexo' },
  ];

  //+================== VARIABLES FOR DIRECTORY ==================+\\
  public Directories: TreeNode[] = [];

  //+===================== FORM ADD ROLE =====================+\\
  public FormRole: FormGroup = new FormGroup({
    NameRole: new FormControl({ value: '', disabled: false }, Validators.required),
    Description: new FormControl({ value: '', disabled: false }, Validators.required),
  });

  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';


  //+================== VARIABLES FOR LOAD PAGE ==================+\\
  public LoadPage: boolean = false;
  public loading: boolean = true;



  //-========================= SERVICES =========================-\\
  private Service_FIN = inject(LibraryFINService);
  private router = inject(Router);

  constructor(private cd: ChangeDetectorRef) { }

  async ngOnInit() {

    await this.Load_Component()

  }

  private async Load_Component(): Promise<void> {
    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader.classList.add('active');

    try {
      this.Directories = [];

      const ResponseDirectories = await firstValueFrom(this.Service_FIN.Get_Dirs_In_Directory_FIN({ path: '' }))

      const data: Folder_Permission_Tree = {
        ID: 0,
        Name: 'Raiz',
        ID_Folder_Top: 0,
        Path: '',
        createFile: false,
        createFolder: false,
        updateFile: false,
        versionHistory: false,
        downloadVersionFlow: false,
        renameFile: false,
        renameFolder: false,
        moveFile: false,
        moveFolder: false,
        sharedFolder: false,
        adminApprovation: false,
        adminRejection: false,
        properties: false,
        deleteFile: false,
        deleteFolder: false,
        versionHistoryAnnexe: false,
        downloadVersionAnnexe: false,
      }

      this.Directories = ResponseDirectories.operation.map((item: Folder_FIN_Path) => this.mapFileNode(item, data))

      Loader.classList.remove('active');

    } catch (e) {
      Swal.fire({
        title: 'Ocurrió un error',
        text: '¡Notifique este error al supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });

      Loader.classList.remove('active');
    }
  }


  //-================== FUNCTTION FOR MAP DIRECTORY ==================-\\
  private mapFileNode(file: Folder_FIN_Path, dataFather: Folder_Permission_Tree): TreeNode {

    const data: Folder_Permission_Tree = {
      ID: file.ID,
      Name: file.Name,
      ID_Folder_Top: file.ID_Folder_Top,
      Path: file.Path,
      createFile: dataFather.createFile,
      createFolder: dataFather.createFolder,
      updateFile: dataFather.updateFile,
      versionHistory: dataFather.versionHistory,
      downloadVersionFlow: dataFather.downloadVersionFlow,
      renameFile: dataFather.renameFile,
      renameFolder: dataFather.renameFolder,
      moveFile: dataFather.moveFile,
      moveFolder: dataFather.moveFolder,
      sharedFolder: dataFather.sharedFolder,
      adminApprovation: dataFather.adminApprovation,
      adminRejection: dataFather.adminRejection,
      properties: dataFather.properties,
      deleteFile: dataFather.deleteFile,
      deleteFolder: dataFather.deleteFolder,
      versionHistoryAnnexe: dataFather.versionHistoryAnnexe,
      downloadVersionAnnexe: dataFather.downloadVersionAnnexe,
    }

    const mapDir: TreeNode = {
      label: file.Name,
      data: data,
      expandedIcon: "fa-solid fa-folder-open",
      collapsedIcon: "fa-solid fa-folder",
      leaf: false,
      children: []
    }
    return mapDir
  }

  public async onNodeExpand(event: any): Promise<void> {

    this.loading = true;

    const Node: TreeNode = event.node;

    if (Node) {

      if (!(Node.children && Node.children.length > 0)) {

        try {

          const childs_response: Response_FIN = await firstValueFrom(this.Service_FIN.Get_Dirs_In_Directory_FIN({ path: Node.data.Path }));

          if (childs_response.success) {


            const Directories: Folder_FIN_Path[] = childs_response.operation;
            const newChildNodes: TreeNode[] = Directories.map((childFile: Folder_FIN_Path) => this.mapFileNode(childFile, Node.data));

            Node.children = newChildNodes
            this.Directories = [...this.Directories]


            this.cd.markForCheck();
          }


        } catch (e) {

          Swal.fire({
            title: 'Ocurrió un error',
            text: '¡Notifique este error al supervisor!',
            icon: 'warning',
            confirmButtonColor: this.ColorConfirm
          })
        }
      }


    }

    this.loading = false;
  }

  public changePermission(rowNode: any, rowData: any, col: ColumnFIN) {
    rowData[col.field] === true ? rowData[col.field] = false : rowData[col.field] = true;
    const check = rowData[col.field]
    this.InheritancePermission(rowNode.node, check, col)
  }

  private InheritancePermission(rowNode: any, check: boolean, col: ColumnFIN): void {
    if (rowNode.children) {
      if (rowNode.children.length > 0) {
        let subdirectories = rowNode.children;
        for (const dir of subdirectories) {
          dir.data[col.field] = check
          this.InheritancePermission(dir, check, col)
        }

      }
    }

  }

  public verify(rowData: any, col: ColumnFIN) {
    return rowData[col.field]
  }


  public async validationRole(): Promise<void> {

    const isValidForm: boolean = this.validateForm();

    const dataCreated: CreateRoleFIN = this.getDataFolder()

    dataCreated.Name = this.FormRole.controls['NameRole'].value;
    dataCreated.Description = this.FormRole.controls['Description'].value;

    if (this.FormRole.valid && isValidForm) {

      if (dataCreated.Folder_Father.length > 0 || dataCreated.Exception.length > 0) {

        Swal.fire({
          title: '¿Confirma que los datos son correctos?',
          text: "Si la información es precisa, por favor presione el botón para crear el rol.",
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: this.ColorConfirm,
          cancelButtonColor: this.ColorsCancel,
          confirmButtonText: '<i class="fa-solid fa-check-double"></i> Sí, confirmar',
          cancelButtonText: 'No, cancelar',
        }).then((async result => {

          if (result.isConfirmed) {
            try {

              const ResCreateRol: Response_FIN = await firstValueFrom(this.Service_FIN.Create_Role_FIN(dataCreated));

              if (ResCreateRol.success) {

                Swal.fire({
                  icon: 'success',
                  title: '¡Operación exitosa!',
                  text: `El rol ${dataCreated.Name} se ha creado correctamente.`,
                  confirmButtonText: 'Aceptar',
                  confirmButtonColor: this.ColorConfirm,
                  cancelButtonColor: this.ColorsCancel,
                }).then((result => {
                  this.router.navigate(['/Dashboard/FIN/SeeAllRolesGenFIN']);
                }))


              } else {
                Swal.fire({
                  icon: 'error',
                  title: 'Error',
                  text: 'Se ha producido un problema al intentar crear el rol. Por favor, intente nuevamente más tarde.',
                  confirmButtonText: 'Aceptar',
                  confirmButtonColor: this.ColorConfirm,
                  cancelButtonColor: this.ColorsCancel,
                });

              }

            } catch (error) {
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Se ha producido un problema al intentar crear el rol. Por favor, intente nuevamente más tarde.',
                confirmButtonText: 'Aceptar',
                confirmButtonColor: this.ColorConfirm,
                cancelButtonColor: this.ColorsCancel,
              });

            }
          }

        }))

      } else {
        Swal.fire({
          icon: 'warning',
          title: 'Directorios no seleccionados',
          text: 'Por favor, seleccione al menos un directorio y sus permisos correspondientes para proceder con la creación del rol.',
          confirmButtonColor: this.ColorConfirm,
          cancelButtonColor: this.ColorsCancel,
        });
      }

    }


  }

  private validateForm(): boolean {
    const inputNameRoleFIN = document.getElementById('inputNameRoleFIN') as HTMLElement;
    const inputDescription = document.getElementById('inputDescription') as HTMLElement;

    if (!this.FormRole.controls['NameRole'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'Nombre no valido',
        text: '¡El nombre del rol es muy corto, mínimo 10 caracteres!',
        confirmButtonColor: this.ColorConfirm
      })
      inputNameRoleFIN.classList.add('ng-invalid'); inputNameRoleFIN.classList.add('ng-touched');
      return false;
    }

    if (!this.FormRole.controls['Description'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'descripción no valida',
        text: '¡La descripción del rol es muy corta, mínimo 15 caracteres!',
        confirmButtonColor: this.ColorConfirm
      })
      inputDescription.classList.add('ng-invalid'); inputDescription.classList.add('ng-touched');
      return false
    }

    return true
  }




  private getDataFolder(): CreateRoleFIN {

    const dataCreate: CreateRoleFIN = { Name: '', Description: '', Folder_Father: [], Exception: [] }
    const deleteFolderRepeat: number[] = [];

    const verify_FolderFatherx = (directory: TreeNode) => {

      const permissions: number[] = this.checkPermission(directory);

      if (permissions.length > 0) {
        dataCreate.Folder_Father.push({ ID_F: directory.data.ID, Permission: permissions })
      }

      if (directory.children && directory.children.length > 0) {
        let subdirectories = directory.children;
        for (const dir of subdirectories) {

          const permissionChild: number[] = this.checkPermission(dir);

          const isSame: boolean = this.ComparePermission(permissions, permissionChild)

          if (!isSame) {
            deleteFolderRepeat.push(dir.data.ID)
            dataCreate.Exception.push({ ID_F: dir.data.ID, ID_Folder_Top: dir.data.ID_Folder_Top, Permission: permissionChild })
          } else {
            deleteFolderRepeat.push(dir.data.ID)
          }

          verify_FolderFatherx(dir)
        }
      }
    }

    for (const dir of this.Directories) {
      verify_FolderFatherx(dir)
    }


    dataCreate.Folder_Father = this.CleanFolderFather(dataCreate.Folder_Father, deleteFolderRepeat);

    return dataCreate
  }

  private checkPermission(directory: TreeNode): number[] {

    const permissions: permissionFIN[] = [];
    const data: Folder_Permission_Tree = directory.data

    if (data.createFile === true) permissions.push({ ID: 1, Name: 'createFile' })
    if (data.createFolder === true) permissions.push({ ID: 2, Name: 'createFolder' })
    if (data.updateFile === true) permissions.push({ ID: 3, Name: 'updateFile' })
    if (data.versionHistory === true) permissions.push({ ID: 4, Name: 'versionHistory' })
    if (data.downloadVersionFlow === true) permissions.push({ ID: 5, Name: 'downloadVersionFlow' })
    if (data.renameFile === true) permissions.push({ ID: 6, Name: 'renameFile' })
    if (data.renameFolder === true) permissions.push({ ID: 7, Name: 'renameFolder' })
    if (data.moveFile === true) permissions.push({ ID: 8, Name: 'moveFile' })
    if (data.moveFolder === true) permissions.push({ ID: 9, Name: 'moveFolder' })
    if (data.sharedFolder === true) permissions.push({ ID: 10, Name: 'sharedFolder' })
    if (data.adminApprovation === true) permissions.push({ ID: 11, Name: 'adminApprovation' })
    if (data.adminRejection === true) permissions.push({ ID: 12, Name: 'adminRejection' })
    if (data.properties === true) permissions.push({ ID: 13, Name: 'properties' })
    if (data.deleteFile === true) permissions.push({ ID: 14, Name: 'deleteFile' })
    if (data.deleteFolder === true) permissions.push({ ID: 15, Name: 'deleteFolder' })
    if (data.versionHistoryAnnexe === true) permissions.push({ ID: 16, Name: 'versionHistoryAnnexe' })
    if (data.downloadVersionAnnexe === true) permissions.push({ ID: 17, Name: 'downloadVersionAnnexe' })


    const permissionNumber: number[] = permissions.map((item: permissionFIN) => (item.ID))

    return permissionNumber.sort((a, b) => a - b);
  }

  private ComparePermission(permissionFather: number[], permissionChild: number[]): boolean {
    if (permissionFather.length !== permissionChild.length) {
      return false;
    }

    for (let i = 0; i < permissionFather.length; i++) {
      if (permissionFather[i] !== permissionChild[i]) {
        return false
      }
    }

    return true

  }

  private CleanFolderFather(FoldersFather: Folder_Father[], foldersFatherRepeat: number[]): Folder_Father[] {

    let FoldersFatherClean: Folder_Father[] = FoldersFather;

    for (const folder of foldersFatherRepeat) {
      FoldersFatherClean = FoldersFatherClean.filter((item: Folder_Father) => item.ID_F !== folder)
    }

    return FoldersFatherClean;

  }
}


